import { createPortal } from 'react-dom';
import isAppEnv, { EnvName } from './is-app-env';

const createVersionPortal = async (
    Component: JSX.Element,
    id: string,
    envNames: EnvName[],
    appendBody = true,
    hidden = true
) => {
    if (!(await isAppEnv(...envNames))) return;

    const el = document.getElementById(id);
    if (el) return el;

    const newEl = document.createElement('div');
    newEl.id = id;
    newEl.style.display = hidden ? 'none' : 'block';

    appendBody && document.body.appendChild(newEl);

    return createPortal(Component, newEl);
};

export default createVersionPortal;
